 import React, { useState } from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// Register necessary components
ChartJS.register(
  ArcElement,
  ChartTooltip,
  Legend
);

const PnbCarLoanEmiCalculator  = () => {
  const [loanAmount, setLoanAmount] = useState(500000);
  const [interestRate, setInterestRate] = useState(8);
  const [loanTenure, setLoanTenure] = useState(5);
  const [monthlyEMI, setMonthlyEMI] = useState(0);
  const [totalInterest, setTotalInterest] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [amortizationSchedule, setAmortizationSchedule] = useState([]);
  const [activeYear, setActiveYear] = useState(null);

  const calculateEMI = () => {
    const principal = loanAmount;
    const annualInterest = interestRate / 100;
    const monthlyInterest = annualInterest / 12;
    const tenureInMonths = loanTenure * 12;

    const emi =
      (principal * monthlyInterest * Math.pow(1 + monthlyInterest, tenureInMonths)) /
      (Math.pow(1 + monthlyInterest, tenureInMonths) - 1);

    const totalAmount = emi * tenureInMonths;
    const totalInterest = totalAmount - principal;

    setMonthlyEMI(emi.toFixed(2));
    setTotalInterest(totalInterest.toFixed(2));
    setTotalAmount(totalAmount.toFixed(2));

    const schedule = [];
    let balance = principal;
    // let currentYear = new Date().getFullYear();
    let currentYear = new Date().getFullYear();

    let currentMonth = 6;

    for (let i = 0; i < tenureInMonths; i++) {
      const interestForMonth = balance * monthlyInterest;
      const principalForMonth = emi - interestForMonth;
      balance -= principalForMonth;

      schedule.push({
        // month: i + 1,
        // year: year,
        month: (currentMonth + i) % 12 + 1, // Ensure month is in range 1-12
        year: currentYear + Math.floor((currentMonth + i) / 12),
        principalPaid: principalForMonth,
        interestPaid: interestForMonth,
        totalPayment: emi,
        balance: balance,
      });

      // if ((i + 1) % 12 === 0) {
      //   year++;
      // }
    }

    setAmortizationSchedule(schedule);
  };

  const handleLoanAmountChange = (e) => {
    const value = e.target.value;
    setLoanAmount(value === '' ? 0 : parseInt(value));
  };

  const handleInterestRateChange = (e) => {
    const value = e.target.value;
    setInterestRate(value === '' ? 0 : parseFloat(value));
  };

  const handleLoanTenureChange = (e) => {
    const value = e.target.value;
    setLoanTenure(value === '' ? 0 : parseInt(value));
  };

  const handleYearToggle = (year) => {
    setActiveYear(activeYear === year ? null : year);
  };

  const data = {
    labels: ['Principal Amount', 'Total Interest'],
    datasets: [
      {
        label: 'EMI Breakdown',
        data: [loanAmount, totalInterest],
        backgroundColor: ['#36A2EB', '#FF6384'],
      },
    ],
  };
function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
     
    const faqs = [
        {
            "question": "What is the PNB Car Loan EMI Calculator?",
            "answer": "It’s a free digital tool on TheFinMaster that calculates your monthly EMI based on loan inputs such as amount, tenure, and interest rate."
          },
          {
            "question": "Is the PNB EMI Calculator accurate?",
            "answer": "Yes, it uses standard mathematical formulas to ensure precise results."
          },
          {
            "question": "Can I use it for used cars?",
            "answer": "Yes, you can enter your used car loan values for accurate EMI estimates."
          },
          {
            "question": "Does it show total interest payable?",
            "answer": "Yes, along with EMI, it also shows total interest payable and amortisation breakdown."
          },
          {
            "question": "Is there any cost to use the calculator?",
            "answer": "No, TheFinMaster’s PNB EMI Calculator is completely free."
          },
          {
            "question": "Can I change the values and calculate again?",
            "answer": "Absolutely. You can enter different loan amounts, tenures, and interest rates multiple times."
          },
          {
            "question": "Will it affect my credit score?",
            "answer": "No. Using the calculator doesn’t involve any credit checks."
          },
          {
            "question": "How is interest calculated in the EMI?",
            "answer": "Interest is calculated monthly and decreases as the loan progresses."
          },
          {
            "question": "Can I get a printable version of the amortisation schedule?",
            "answer": "Yes, many calculators offer a download or print feature."
          },
          {
            "question": "Can I prepay the loan to reduce EMI?",
            "answer": "Yes, prepayment lowers your outstanding principal and reduces your future EMIs."
          },
          {
            "question": "Is this calculator approved by PNB?",
            "answer": "This is an independent tool designed for educational use. For official rates, check with PNB."
          },
          {
            "question": "Can I apply for a PNB car loan from TheFinMaster?",
            "answer": "Yes, we guide users through the loan application process with various banks."
          },
          {
            "question": "What are the minimum and maximum tenures allowed?",
            "answer": "Tenure typically ranges from 1 to 7 years depending on the car and borrower profile."
          },
          {
            "question": "Does the calculator adjust for floating interest rates?",
            "answer": "No, it assumes a fixed rate for simplicity."
          },
          {
            "question": "Can I use this for loan top-ups?",
            "answer": "Yes, just input the top-up amount separately and calculate the EMI accordingly."
          }
        ]
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
  return (
    <>
     <Helmet>
         {/* <title>Gold Loan EMI Calculator: Online Gold Loan EMI Calculator For - TheFinmaster</title>
        <meta  name='description' content='Home Loan EMI Calculator helps you calculate EMI of your housing loan required to pay for your dream home. Know about Online Home Loan EMI Calculator here! | TheFinmaster'/>
        <meta name='keywords' content='car loan emi calculator, car emi calculator, auto emi calculator, vehicle emi calculator, car finance emi calculator, automobile loan emi calculator, monthly emi calculator car loan' /> */}
        {/* <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/car-loan-emi-calculator" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" /> */}
      </Helmet>
      <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
        <li className="flex items-center">
          <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
          <li className="flex items-center">
          <span className="text-gray-500 ">PNB Loan EMI Calculator</span>
        </li> 
      
      </ol>
    </nav>
        <div className='py-4'>
    <div className="container mx-auto p-4 shadow-xl rounded-md">
      <h1 className="text-2xl font-bold mb-4">PNB Car Loan EMI Calculator</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Amount</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                value={loanAmount}
                onChange={handleLoanAmountChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">₹ {loanAmount.toLocaleString()}</span>
            </div>
            <input
              type="range"
              min="0"
              max="10000000"
              value={loanAmount}
              onChange={(e) => setLoanAmount(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Rate of Interest (P.A.)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="100"
                step="0.1"
                value={interestRate}
                onChange={handleInterestRateChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{interestRate} %</span>
            </div>
            <input
              type="range"
              min="0"
              max="15"
              step="0.1"
              value={interestRate}
              onChange={(e) => setInterestRate(parseFloat(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Tenure (Years)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="30"
                value={loanTenure}
                onChange={handleLoanTenureChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{loanTenure} Yr</span>
            </div>
            <input
              type="range"
              min="0"
              max="30"
              value={loanTenure}
              onChange={(e) => setLoanTenure(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <button
            onClick={calculateEMI}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Calculate
          </button>
        </div>
        <div>
          <div className="mb-4">
            <h2 className="text-xl font-bold">Results</h2>
            <p>Monthly EMI: ₹ {parseFloat(monthlyEMI).toLocaleString()}</p>
            <p>Total Principal Amount: ₹ {loanAmount.toLocaleString()}</p>
            <p>Total Interest: ₹ {parseFloat(totalInterest).toLocaleString()}</p>
            <p>Total Amount (Principal + Interest): ₹ {parseFloat(totalAmount).toLocaleString()}</p>
          </div>
          <div>
            <h2 className="text-xl font-bold">Breakdown</h2>
            <div className="flex justify-center">
              <Pie data={data} options={{ maintainAspectRatio: false }} width={300} height={300} />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6">
        <h2 className="text-xl font-bold mb-4">Amortization Schedule</h2>
        {amortizationSchedule.length > 0 && (
          <div className="flex flex-col space-y-4">
            {Array.from(new Set(amortizationSchedule.map(item => item.year))).map((year, idx) => (
              <div key={idx} className="mb-4 border rounded-md shadow-md">
                <div
                  className={`cursor-pointer text-lg font-semibold bg-gray-100 p-4 flex justify-between items-center ${activeYear === year ? 'bg-blue-100' : ''}`}
                  onClick={() => handleYearToggle(year)}
                >
                  <span>{year}</span>
                  <span>{activeYear === year ? '-' : '+'}</span>
                </div>
                {activeYear === year && (
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white rounded-md shadow-md">
                      <thead>
                        <tr>
                          <th className="py-2 px-4 border-b">Month</th>
                          <th className="py-2 px-4 border-b">Principal Paid</th>
                          <th className="py-2 px-4 border-b">Interest Charged</th>
                          <th className="py-2 px-4 border-b">Total Payment</th>
                          <th className="py-2 px-4 border-b">Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        {amortizationSchedule.filter(item => item.year === year).map((item, idx) => (
                          <tr key={idx}>
                            <td className="py-2 px-4 border-b">{new Date(0, item.month - 1).toLocaleString('default', { month: 'short' })}</td>
                            <td className="py-2 px-4 border-b">₹ {item.principalPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.interestPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.totalPayment.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.balance.toFixed(2).toLocaleString()}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
     <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
    <div className="w-full md:w-2/3 p-4 mx-auto">
    <div className="container mx-auto py-4">
          <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            Plan Your PNB Car Loan Payments with TheFinMaster’s EMI Calculator
          </h1>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Looking to finance your dream car with Punjab National Bank (PNB)? Planning your monthly repayments smartly is essential to avoid financial stress and ensure a smooth loan journey. TheFinMaster’s PNB Car Loan EMI Calculator empowers you to estimate your monthly EMIs accurately, understand your amortisation schedule in-depth, and make better-informed financial decisions. Whether you're purchasing a hatchback, sedan, or SUV, our EMI calculator simplifies your budgeting process and offers clarity in seconds.
          </p>
</div>
          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is a Car Loan EMI?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              A Car Loan EMI (Equated Monthly Instalment) is the fixed payment amount made by a borrower to the bank every month until the loan is fully repaid. Each EMI comprises two essential components — the principal amount and the interest component. In the earlier stages of repayment, the interest component is higher, which gradually decreases over time as the principal component increases.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              For example, if you avail of a PNB car loan of ₹7 lakhs at an interest rate of 8.50% for a tenure of 5 years, your EMI would include a mix of both interest and principal portions. Over the course of time, the balance between the two shifts, with more of your EMI going toward the principal.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Understanding EMI helps you:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Plan your monthly finances</li>
              <li>Avoid defaulting or late payments</li>
              <li>Evaluate loan affordability</li>
              <li>Compare different loan offers</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is the PNB Car Loan EMI Calculator?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The PNB Car Loan EMI Calculator on TheFinMaster is an intuitive, user-friendly digital tool that helps prospective car loan borrowers calculate their monthly repayments in advance. It provides precise EMI calculations based on the loan amount, interest rate, and loan tenure entered by the user.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Unlike manual calculations that require financial formulas and time, our EMI calculator delivers instant results with just a few clicks. It also breaks down the amortisation schedule and gives you full visibility into how your loan will be repaid over time, month by month.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Benefits of using this calculator:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>No need for manual math or spreadsheets</li>
              <li>Save time and make faster decisions</li>
              <li>100% accurate and customizable results</li>
              <li>Instant calculation with real-time changes</li>
              <li>Understand your long-term financial obligations clearly</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Use TheFinMaster’s PNB Car Loan EMI Calculator?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using TheFinMaster’s PNB Car Loan EMI Calculator offers a multitude of advantages to borrowers who want to take control of their financial planning. Here's why it stands out:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>User-Friendly Interface:</strong> The calculator is simple to navigate, making it easy even for first-time loan seekers to estimate their EMIs.</li>
              <li><strong>Highly Accurate Results:</strong> The tool employs complex EMI formulas at the backend to offer precise, error-free results every time.</li>
              <li><strong>Customisation:</strong> You can tweak the inputs — like loan amount, interest rate, and tenure — multiple times to see different EMI scenarios.</li>
              <li><strong>Amortisation Insights:</strong> Besides monthly EMI, the tool gives you a detailed amortisation schedule that shows the principal and interest split for each month.</li>
              <li><strong>Helps in Loan Comparison:</strong> Before choosing a car loan, you can compare offers from different banks by entering respective interest rates and tenures.</li>
              <li><strong>Transparency and Clarity:</strong> Understand how much you'll be paying over the entire loan tenure, helping you avoid hidden surprises.</li>
              <li><strong>Financial Preparedness:</strong> By knowing your monthly EMI in advance, you can assess your budget and avoid any future financial strain.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does the PNB Car Loan EMI Calculator Work?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The PNB Car Loan EMI Calculator operates on a straightforward mathematical formula:
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              EMI = [P x R x (1+R)^N] / [(1+R)^N – 1]
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>P = Principal loan amount</li>
              <li>R = Monthly interest rate (annual rate divided by 12 x 100)</li>
              <li>N = Number of monthly installments</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Example:</strong><br />
              Let’s say you want a car loan of ₹9,00,000 from PNB for a period of 6 years at an interest rate of 9% per annum.<br />
              Loan Amount (P): ₹9,00,000<br />
              Interest Rate (R): 9% per annum or 0.0075 monthly<br />
              Loan Tenure (N): 72 months<br />
              Using the EMI formula, your monthly EMI would be approximately ₹16,137.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This EMI includes both the principal and interest components, and using the calculator, you can view a complete amortisation schedule as shown below.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is the Amortisation Schedule?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              An amortisation schedule is a tabular representation of how your car loan will be repaid over time. It breaks down each monthly EMI into its principal and interest components and shows the balance outstanding after each payment.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This schedule gives borrowers a clear understanding of:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>How much of each EMI goes toward interest vs. principal</li>
              <li>How the loan balance reduces over time</li>
              <li>The exact timeline of your loan repayment</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Sample 12-Month Amortisation Schedule:</strong>
            </p>
            {/* <div className="overflow-x-auto">
              <table className="w-full text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-4 border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-4 py-2 text-left">Month</th>
                    <th className="border px-4 py-2 text-left">EMI (₹)</th>
                    <th className="border px-4 py-2 text-left">Principal (₹)</th>
                    <th className="border px-4 py-2 text-left">Interest (₹)</th>
                    <th className="border px-4 py-2 text-left">Outstanding Balance (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border px-4 py-2">1</td>
                    <td className="border px-4 py-2">16,137</td>
                    <td className="border px-4 py-2">9,637</td>
                    <td className="border px-4 py-2">6,500</td>
                    <td className="border px-4 py-2">8,90,363</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">2</td>
                    <td className="border px-4 py-2">16,137</td>
                    <td className="border px-4 py-2">9,693</td>
                    <td className="border px-4 py-2">6,444</td>
                    <td className="border px-4 py-2">8,80,670</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">3</td>
                    <td className="border px-4 py-2">16,137</td>
                    <td className="border px-4 py-2">9,749</td>
                    <td className="border px-4 py-2">6,388</td>
                    <td className="border px-4 py-2">8,70,921</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">4</td>
                    <td className="border px-4 py-2">16,137</td>
                    <td className="border px-4 py-2">9,805</td>
                    <td className="border px-4 py-2">6,332</td>
                    <td className="border px-4 py-2">8,61,116</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">5</td>
                    <td className="border px-4 py-2">16,137</td>
                    <td className="border px-4 py-2">9,862</td>
                    <td className="border px-4 py-2">6,275</td>
                    <td className="border px-4 py-2">8,51,254</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">6</td>
                    <td className="border px-4 py-2">16,137</td>
                    <td className="border px-4 py-2">9,918</td>
                    <td className="border px-4 py-2">6,219</td>
                    <td className="border px-4 py-2">8,41,336</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">7</td>
                    <td className="border px-4 py-2">16,137</td>
                    <td className="border px-4 py-2">9,975</td>
                    <td className="border px-4 py-2">6,162</td>
                    <td className="border px-4 py-2">8,31,361</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">8</td>
                    <td className="border px-4 py-2">16,137</td>
                    <td className="border px-4 py-2">10,032</td>
                    <td className="border px-4 py-2">6,105</td>
                    <td className="border px-4 py-2">8,21,329</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">9</td>
                    <td className="border px-4 py-2">16,137</td>
                    <td className="border px-4 py-2">10,089</td>
                    <td className="border px-4 py-2">6,048</td>
                    <td className="border px-4 py-2">8,11,240</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">10</td>
                    <td className="border px-4 py-2">16,137</td>
                    <td className="border px-4 py-2">10,146</td>
                    <td className="border px-4 py-2">5,991</td>
                    <td className="border px-4 py-2">8,01,094</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">11</td>
                    <td className="border px-4 py-2">16,137</td>
                    <td className="border px-4 py-2">10,203</td>
                    <td className="border px-4 py-2">5,934</td>
                    <td className="border px-4 py-2">7,90,891</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">12</td>
                    <td className="border px-4 py-2">16,137</td>
                    <td className="border px-4 py-2">10,260</td>
                    <td className="border px-4 py-2">5,877</td>
                    <td className="border px-4 py-2">7,80,631</td>
                  </tr>
                </tbody>
              </table>
            </div> */}

            <div className="mt-6">
  {/* Table view for medium and up */}
  <div className="hidden md:block overflow-x-auto">
    <table className="w-full text-lg text-gray-600 mt-4 border-collapse">
      <thead>
        <tr className="bg-gray-100">
          <th className="border px-4 py-2 text-left">Month</th>
          <th className="border px-4 py-2 text-left">EMI(₹)</th>
          <th className="border px-4 py-2 text-left">Principal (₹)</th>
          <th className="border px-4 py-2 text-left">Interest (₹)</th>
          <th className="border px-4 py-2 text-left">Outstanding Balance (₹)</th>
        </tr>
      </thead>
      <tbody>
        {[
          
       
          ["1", "₹16,137", "₹9,637", "₹6,500", "₹8,90,363"],
          ["2", "₹16,137", "₹9,693", "₹6,444", "₹8,80,670"],
          ["3", "₹16,137", "₹9,749", "₹6,388", "₹8,70,921"],
          ["4", "₹16,137", "₹9,805", "₹6,332", "₹8,61,116"],
          ["5", "₹16,137", "₹9,862", "₹6,275", "₹8,51,254"],
          ["6", "₹16,137", "₹9,918", "₹6,219", "₹8,41,336"],
          ["7", "₹16,137", "₹9,975", "₹6,162", "₹8,31,361"],
          ["8", "₹16,137", "₹10,032", "₹6,105", "₹8,21,329"],
          ["9", "₹16,137", "₹10,089", "₹6,048", "₹8,11,240"],
          ["10", "₹16,137", "₹10,146", "₹5,991", "₹8,01,094"],
          ["11", "₹16,137", "₹10,203", "₹5,934", "₹7,90,891"],
          ["12", "₹16,137", "₹10,260", "₹5,877", "₹7,80,631"]
     
        ].map(([month, emi, interest, principal, balance], index) => (
          <tr key={index}>
            <td className="border px-4 py-2">{month}</td>
            <td className="border px-4 py-2">{emi}</td>
            <td className="border px-4 py-2">{interest}</td>
            <td className="border px-4 py-2">{principal}</td>
            <td className="border px-4 py-2">{balance}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Card layout for small screens */}
  <div className="md:hidden space-y-4 mt-4">
    {[
           ["1", "₹16,137", "₹9,637", "₹6,500", "₹8,90,363"],
           ["2", "₹16,137", "₹9,693", "₹6,444", "₹8,80,670"],
           ["3", "₹16,137", "₹9,749", "₹6,388", "₹8,70,921"],
           ["4", "₹16,137", "₹9,805", "₹6,332", "₹8,61,116"],
           ["5", "₹16,137", "₹9,862", "₹6,275", "₹8,51,254"],
           ["6", "₹16,137", "₹9,918", "₹6,219", "₹8,41,336"],
           ["7", "₹16,137", "₹9,975", "₹6,162", "₹8,31,361"],
           ["8", "₹16,137", "₹10,032", "₹6,105", "₹8,21,329"],
           ["9", "₹16,137", "₹10,089", "₹6,048", "₹8,11,240"],
           ["10", "₹16,137", "₹10,146", "₹5,991", "₹8,01,094"],
           ["11", "₹16,137", "₹10,203", "₹5,934", "₹7,90,891"],
           ["12", "₹16,137", "₹10,260", "₹5,877", "₹7,80,631"]
    ].map(([month, emi, interest, principal, balance], index) => (
      <div key={index} className="bg-white shadow rounded-xl p-4 text-sm text-gray-700 space-y-1 border">
        <div><span className="font-semibold">Month:</span> {month}</div>
        <div><span className="font-semibold">EMI  (₹):</span> {emi}</div>
        <div><span className="font-semibold">Interest  (₹):</span> {interest}</div>
        <div><span className="font-semibold">Principal  (₹):</span> {principal}</div>
        <div><span className="font-semibold"> Outstanding(₹):</span> {balance}</div>
      </div>
    ))}
  </div>
</div>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Factors Affecting Your Car Loan EMI
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Several variables can impact your EMI amount when you take a PNB car loan. Understanding these factors can help you choose the most optimal loan offer and better manage your monthly finances.
            </p>
            <ul className="list-decimal pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Loan Amount</strong><br />
                A higher principal leads to higher EMIs. Always borrow according to your repayment capability.
              </li>
              <li><strong>Interest Rate</strong><br />
                The rate offered by PNB plays a critical role. Even a small difference in rate can make a significant impact over long tenures.
              </li>
              <li><strong>Loan Tenure</strong><br />
                A longer tenure reduces your monthly EMI but increases total interest outgo. A shorter tenure results in higher EMIs but lower interest payments.
              </li>
              <li><strong>Credit Score</strong><br />
                A strong credit score (750+) often helps in negotiating a better interest rate, thus reducing EMI.
              </li>
              <li><strong>Down Payment</strong><br />
                Making a higher down payment lowers your loan amount and EMI accordingly.
              </li>
              <li><strong>Type of Car and Insurance Premiums</strong><br />
                Some banks consider the car model and its insurance premium while determining EMI eligibility, especially in bundled offers.
              </li>
              <li><strong>Income and Employment Status</strong><br />
                Your monthly income, job stability, and employer profile can affect both your loan approval and applicable interest rate.
              </li>
            </ul>
          </div>
        </div>

     <div className="w-full md:w-1/3 p-4">
       <div className="bg-white shadow-md rounded-lg overflow-hidden">
         <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
           <h2 className="text-lg font-semibold ">Popular Categories</h2>
         </div>
         <div className="p-2 ">
         <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
             {/* {moreCategories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
           </ul>
         </div>
       </div>

     </div>

   </div>
   </div>
   <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h1 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h1>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
   </>
  );
};

export default PnbCarLoanEmiCalculator ;
